import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getMediaUrl = (section, groupKey) => {
  const media =
    section?.media?.groups?.[groupKey]?.[0] ||
    (groupKey === 'background' || groupKey === 'hero-image'
      ? section?.media?.primary
      : null);

  return media?.url ? resolveMediaUrl(media.url) : '';
};

export const parseMarketDetailHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const image = getMediaUrl(section, 'hero-image');

  if (!fields.title) {
    return null;
  }

  return {
    category: fields.eyebrow || '',
    title: fields.title,
    description: fields.text || '',
    cta: {
      text: fields.ctaText || 'Open an Account',
      url: fields.ctaUrl || '/create-account',
    },
    image,
  };
};

export const parseMarketDetailGlobalCompaniesContent = (page) => {
  const section = getSection(page, 'global-companies');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const paragraphs = [];
  for (let index = 1; index <= 10; index += 1) {
    const value = fields[`paragraph-${index}`];
    if (!value) {
      break;
    }
    paragraphs.push(value);
  }

  return {
    title: fields.title,
    paragraphs,
    image: getMediaUrl(section, 'feature-image'),
  };
};

export const parseMarketDetailMarketSegmentsContent = (page) => {
  const section = getSection(page, 'market-segments');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`segment-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      title,
      text: fields[`segment-${index}-text`] || '',
      icon: getMediaUrl(section, `segment-${index}-icon`),
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || '',
    items,
  };
};

export const parseMarketDetailFeaturedCompaniesContent = (page) => {
  const section = getSection(page, 'featured-companies');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 20; index += 1) {
    const name = fields[`company-${index}-name`];
    if (!name) {
      break;
    }

    items.push({
      name,
      category: fields[`company-${index}-category`] || '',
      text: fields[`company-${index}-text`] || '',
      logo: getMediaUrl(section, `company-${index}-logo`),
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || 'Featured Companies',
    items,
  };
};

export const parseMarketDetailMarketAccessContent = (page) => {
  const section = getSection(page, 'market-access');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const items = [];
  for (let index = 1; index <= 10; index += 1) {
    const value = fields[`item-${index}`];
    if (!value) {
      break;
    }
    items.push(value);
  }

  return {
    title: fields.title,
    text: fields.text || '',
    items,
    cta: {
      text: fields.ctaText || 'Become a Client',
      url: fields.ctaUrl || '/create-account',
    },
    checkIcon: getMediaUrl(section, 'check-icon'),
    image: getMediaUrl(section, 'feature-image'),
  };
};

export const parseMarketDetailRiskContent = (page) => {
  const section = getSection(page, 'risk');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.text) {
    return null;
  }

  return {
    title: fields.title || 'Risk Considerations',
    text: fields.text,
    eagleImage: getMediaUrl(section, 'eagle-image'),
  };
};

export const parseMarketDetailStartContent = (page) => {
  const section = getSection(page, 'start');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || 'Open an Account',
      url: fields.ctaUrl || '/create-account',
    },
  };
};

export const parseMarketDetailContent = (page) => {
  if (!page) {
    return null;
  }

  return {
    hero: parseMarketDetailHeroContent(page),
    globalCompanies: parseMarketDetailGlobalCompaniesContent(page),
    marketSegments: parseMarketDetailMarketSegmentsContent(page),
    featuredCompanies: parseMarketDetailFeaturedCompaniesContent(page),
    marketAccess: parseMarketDetailMarketAccessContent(page),
    risk: parseMarketDetailRiskContent(page),
    start: parseMarketDetailStartContent(page),
  };
};
